module.exports = __webpack_public_path__ + "assets/8f32ec4fca16a1ca7a26cca89ebf1d07.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/sounds/buttons/recall.mp3
 ** module id = 28
 ** module chunks = 0
 **/